<template>
  <nav id="global-nav" class="navbar">
    <div class="logo">
      <router-link :to="{name: 'mypage'}">
        <i class="c-icon cachalog-logo is-cs-0"></i>
      </router-link>
    </div>
    <div id="account-icon">
      <router-link v-if="$store.getters.isSignIn" :to="{name: 'user', params: {uid: user.uid}}">
        <figure class="image is-32x32" v-if="image">
          <cachalog-img class="is-rounded" :caption="image.caption" :type="'background'"
          :full-path="image.full_path" :source="image.source"></cachalog-img>
        </figure>
        <i class="c-icon cachalog-user" v-else>
          <span class="path1"></span><span class="path2"></span><span class="path3"></span>
        </i>
      </router-link>
      <span v-else @click="signIn">
        <i class="c-icon cachalog-user">
          <span class="path1"></span><span class="path2"></span><span class="path3"></span>
        </i>
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  props: ['user'],
  data: () => ({
    startUrl: '/'
  }),
  computed: {
    image () {
      return this.user.images ? this.user.images[0] : null
    },
    destination: () => location.href
  },
  methods: {
    signIn () {
      if (this.$route.matched[0].name !== 'sign-in') {
        this.$router.push({name: 'sign-in', query: {destination: location.href}})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/global-nav.vue